<div
    class="aix-form__group aix-form__group--rich-text"
    [class.aix-disabled]="isDisabled()"
    [class.aix-form__control--dirty]="isDirty()"
    [class.aix-form__control--invalid]="!isValid()"
    [class.aix-form__control--invalid-required]="isRequired() && !rawValue()"
    [class.aix-form__control--invalid-disabled]="isDisabled() && !isValid()"
>
    <ngx-editor-menu
        [editor]="editor"
        [toolbar]="toolbar"
        [customMenuRef]="customAddLink"
    ></ngx-editor-menu>

    <ngx-editor
        class="aix-form__control aix-form__control--rich-text"
        [style.height.px]="height() || null"
        [attr.disabled]="isDisabled() || null"
        [attr.required]="isRequired() || null"
        [class.aix-disabled]="isDisabled()"
        [editor]="editor"
        [placeholder]="''"
    ></ngx-editor>

    <label class="aix-form__label aix-label label">
        <ng-content></ng-content>
    </label>
</div>

<ng-template #customAddLink>
    <div class="NgxEditor__Seperator"></div>
    <aix-rich-text-add-link [editor]="editor"></aix-rich-text-add-link>
</ng-template>
